/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
import { API, Auth } from 'aws-amplify';
import jwt_decode from 'jwt-decode';
import { fileToBase64 } from '../utils/dataDictionaryUtils';
import {
  listDeployments,
  getDeployment,
  getMachineTelemetryConsumption,
  getMachineTelemetryConsumptionCSV,
  getBrandConsumptions,
  getPermissions,
  listAssetsNotDeleted,
  uploadAssetsFromPackage,
  getTelemetryObject,
  createSerialDeploy,
  createRegexDeploy,
  createMarketDeploy,
  createGlobalDeploy,
  deleteDeploy,
  updateDeployment,
  getProjects,
  deleteAsset,
  getLifeCycleObject,
  getLifeCycleObjectPaginated,
  updateAssetDescription,
  getSandboxObject,
  getSandboxObjectCSV,
  getAssetTypes,
  getDeploymentFileTypes,
  getAsset,
  getCognitoUsersGroupsCSV,
  getActionsBetweenDates,
  getActionsBetweenDatesWithEmail,
  getActionStatistics,
  getNotifications,
  getConfig,
  getUnreadNotificationsCount,
  getUnreadNotifications,
  createNotification,
  markAsReadMutation,
  deleteNotification,
  getBrandConsumptionsCSV,
  getTelemetryObjectCSV,
  getLifeCycleObjectCSV,
  updateConfig,
  getBundle,
  getBundles,
  getBundleFileTypes,
  deleteBundle,
  createBundle,
  updateBundle,
  getSRFfunctions,
  getSRFBackends,
  executeSRF,
  getSRFToken,
  getSRFRequest,
  getSRFRequests,
  cancelSRF,
  getCertificateQuota,
  getCertificateStatus,
  deleteNotificationsByTitle,
  getBundleDeployments,
  deleteWave,
  listPaginatedWaves,
  getWaveById,
  updateWave as updateWaveObject,
  onboardingDevice,
  subscribeToTopic,
  getIotMessages,
  getDevicesPermissionsByProject,
  createDevicePermission,
  deleteDevicePermission,
  getDeviceConnectivityStatus,
  getDeviceConnectivityStatusHistory,
  getDeviceHistory,
  getGatewayHistory,
  getModuleHistory,
  getDeviceSnapHistory,
  getModuleSnapHistory,
  getShadowState,
  getNewUsersBetweenDates,
  getLastUsersAction,
  getUsersFromCognito,
  getAnonymousQuickSightUrl,
  getCognitoUsersByEmail,
  getCognitoUsersFiltered,
  deleteCognitoUserByUserId,
  deleteMyAccount,
  addGroupToUser,
  removeGroupFromUser,
  createCognitoUser,
  checkGroupExists,
  createCognitoGroup,
  getCongitoUsersPaginated,
  UPDATE_USER_LAST_LOGIN_DATE,
  getAuditLogs,
  createAuditLog,
  createNewCredential,
  updateCertificateQuota,
  disablePhysicalUser,
  enablePhysicalUser,
  getPhysicalUserTemplates,
  attachTemplateToPhysicalUser,
  detachTemplateFromPhysicalUser,
  getChangeRequestStatus,
  getPolicyTemplateDetails,
  createPolicyTemplate,
  updatePolicyTemplate,
  deletePolicyTemplate,
  listVariables,
  createVariable,
  updateVariable,
  deleteVariable,
  deleteAccessKeys,
  deletePhysicalUserMutation,
  rotateCredential,
  getPhysicalUsers,
  getPhysicalUser,
  getTemplates,
  updateLogicalUser,
  updateLogicalUserGpgKey,
  rotateLinkedCredentials,
  getDeviceInfo,
  getCandidates,
  getMachineCountKpis,
  getMachineListKpis,
  triggerRubiqAgent,
  onRubiqAgentQueryResponse,
  fetchDeviceKnowledge,
  exportRecipes as exportRecipesQuery,
  exportEvents as exportEventsQuery,
  exportSubevents as exportSubeventsQuery,
  exportProducts as exportProductsQuery,
  importRecipes as importRecipesQuery,
  importEvents as importEventsQuery,
  importSubevents as importSubeventsQuery,
  importProducts as importProductsQuery,
  generateReleaseCandidate,
  getReleases,
  deployReleaseCandidate,
  getDeviceQuarantineStatus,
  blockDevice,
  releaseDevice,
  estimateExportDuration,
} from '../config/graphql';
import S3Service from './s3Service';
import mapRoleToPermissions from '../config/permissionsMapper';
import getCurrentAuthenticatedUserId from '../utils/getCurrentAuthenticatedUserId';

export default class GraphqlService {
  static async getProjects() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const { accessToken } = user.signInUserSession;
      const { jwtToken } = accessToken;
      const decodedToken = jwt_decode(jwtToken);

      // Check if the user has any groups
      const hasGroups = !!((decodedToken['cognito:groups'] && decodedToken['cognito:groups'].length > 0)
        || (decodedToken.groups && decodedToken.groups.length > 0));

      if (!hasGroups) {
        return [];
      }

      const postData = await API.graphql({
        query: getProjects,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getProjects.__typename === 'GetProjectsSuccess') {
        return postData.data.getProjects.projects;
      }
      return Promise.reject(new Error(postData.data.getProjects.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getCognitoUsersGroupsCSV() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getCognitoUsersGroupsCSV,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getCognitoUsersGroupsCSV.__typename === 'GetCognitoUsersGroupsCSVSuccess') {
        return postData.data.getCognitoUsersGroupsCSV.csvData;
      }
      return Promise.reject(new Error(postData.data.getCognitoUsersGroupsCSV.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getActionsBetweenDates({
    from, to, email, page, limit,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const variables = email ? {
        from, to, email, page, limit,
      } : {
        from, to, page, limit,
      };
      const query = email ? getActionsBetweenDatesWithEmail : getActionsBetweenDates;
      const postData = await API.graphql({
        query,
        variables,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getActionsBetweenDates.__typename === 'GetActionsSuccess') {
        return postData.data.getActionsBetweenDates;
      }
      return Promise.reject(new Error(postData.data.getActionsBetweenDates.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getActionStatistics(from, to, projectId) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const graphQlResult = await API.graphql({
        variables: { from, to, projectId },
        query: getActionStatistics,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (graphQlResult.errors || !graphQlResult.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (graphQlResult.data.getActionStatistics.__typename === 'GetActionStatisticsSuccess') {
        return graphQlResult.data.getActionStatistics.data;
      }
      return Promise.reject(new Error(graphQlResult.data.getActionStatistics.message));
    } catch (data) {
      console.error('Error getActionStatistics: ', data);
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getMachineCountKpis({
    projectId,
    deployId,
    sync,
    page_size,
    page,
    groupBy,
    lastCheckForUpdate,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const graphQlResult = await API.graphql({
        variables: {
          projectId,
          deployId,
          sync,
          page_size,
          page,
          groupBy,
          lastCheckForUpdate,
        },
        query: getMachineCountKpis,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (graphQlResult.errors || !graphQlResult.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (graphQlResult.data.getMachineCountKpis.__typename === 'GetMachineCountKpisSuccess') {
        return graphQlResult.data.getMachineCountKpis.result;
      }
      return Promise.reject(new Error(graphQlResult.data.getMachineCountKpis.message));
    } catch (data) {
      console.error('Error getMachineCountKpis: ', data);
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getMachineListKpis({
    projectId,
    deployId,
    sync,
    page_size,
    page,
    groupBy,
    lastCheckForUpdate,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const graphQlResult = await API.graphql({
        variables: {
          projectId,
          deployId,
          sync,
          page_size,
          page,
          groupBy,
          lastCheckForUpdate,
        },
        query: getMachineListKpis,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (graphQlResult.errors || !graphQlResult.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (graphQlResult.data.getMachineListKpis.__typename === 'GetMachineListKpisSuccess') {
        return graphQlResult.data.getMachineListKpis.result;
      }
      return Promise.reject(new Error(graphQlResult.data.getMachineListKpis.message));
    } catch (data) {
      console.error('Error getMachineListKpis: ', data);
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getPermissions(projectId, permissions) {
    const user = await Auth.currentAuthenticatedUser();
    let rawPermissions = permissions;
    if (!permissions) {
      // calculate the rawPermissions with the token
      const decodedToken = jwt_decode(user.signInUserSession.accessToken.jwtToken);
      if (decodedToken) {
        const rawGroups = decodedToken['cognito:groups'] ? decodedToken['cognito:groups'] : decodedToken.groups;
        // eslint-disable-next-line no-param-reassign
        rawPermissions = mapRoleToPermissions(rawGroups);
      }
    }

    const postData = await API.graphql({
      query: getPermissions,
      variables: {
        projectId,
        rawPermissions,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    return postData.data.getFrontendPermissions.permissions;
  }

  static async listAssetsNotDeleted({
    projectId, page, pageSize, sortDirection, type, assetDescriptionValue, assetDescriptionKey,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: listAssetsNotDeleted,
        variables: {
          projectId, page, pageSize, sortDirection, type, assetDescriptionValue, assetDescriptionKey,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.listAssetsNotDeleted.__typename === 'ListAssetsNotDeletedSuccess') {
        return postData.data.listAssetsNotDeleted;
      }
      return Promise.reject(new Error(postData.data.listAssetsNotDeleted.message));
    } catch (data) {
      console.error('Error: ', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getAsset({
    projectId, fileId,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const response = await API.graphql({
        query: getAsset,
        variables: {
          projectId, fileId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!response.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (response.data.getAsset.__typename === 'GetAssetSuccess') {
        return response.data.getAsset;
      }
      return Promise.reject(new Error(response.data.getAsset.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error in getAsset: ${data.errors[0].message}`));
    }
  }

  static async getAssetTypes({
    projectId,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const graphqlData = await API.graphql({
        query: getAssetTypes,
        variables: {
          projectId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!graphqlData.data) {
        return Promise.reject(new Error('Internal Server Error in GetAssetTypesSuccess'));
      }
      if (graphqlData.data.getAssetTypes.__typename === 'GetAssetTypesSuccess') {
        return graphqlData.data?.getAssetTypes?.response;
      }
      return Promise.reject(new Error(graphqlData.data.getAssetTypes.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getDeploymentFileTypes({
    projectId,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const graphqlData = await API.graphql({
        query: getDeploymentFileTypes,
        variables: {
          projectId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!graphqlData.data) {
        return Promise.reject(new Error('Internal Server Error in GetDeploymentFileTypesSuccess'));
      }
      if (graphqlData.data.getDeploymentFileTypes.__typename === 'GetDeploymentFileTypesSuccess') {
        return graphqlData.data?.getDeploymentFileTypes?.response;
      }
      return Promise.reject(new Error(graphqlData.data.getDeploymentFileTypes.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async listDeployments({
    projectId,
    page,
    pageSize,
    sortDirection,
    fileType,
    deleted,
    deployDescriptionKey,
    deployDescriptionValue,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: listDeployments,
        variables: {
          projectId, page, pageSize, sortDirection, fileType, deleted, deployDescriptionKey, deployDescriptionValue,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.listDeployments.__typename === 'ListDeploymentsSuccess') {
        return postData.data.listDeployments;
      }
      return Promise.reject(new Error(postData.data.listDeployments.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getDeployment({
    projectId, deploymentID,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getDeployment,
        variables: {
          projectId,
          deploymentID,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getDeployment.__typename === 'GetDeploymentSuccess') {
        return postData.data.getDeployment.result;
      }
      return Promise.reject(new Error(postData.data.getBundle.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async listBundles(
    {
      projectId,
      sortDirection,
      fileType,
      page,
      pageSize,
      deleted,
      releaseDescriptionValue,
      releaseDescriptionKey,
    },
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser();

      const postData = await API.graphql({
        query: getBundles,
        variables: {
          projectId,
          sortDirection,
          fileType,
          page,
          pageSize,
          deleted,
          releaseDescriptionValue,
          releaseDescriptionKey,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getBundles.__typename === 'GetBundlesSuccess') {
        return postData.data.getBundles;
      }
      return Promise.reject(new Error(postData.data.getBundles.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getBundle({
    projectId, releaseID,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getBundle,
        variables: {
          projectId,
          releaseID,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getBundle.__typename === 'GetBundleSuccess') {
        return postData.data.getBundle.result;
      }
      return Promise.reject(new Error(postData.data.getBundle.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getBundleDeployments({
    projectId, releaseID,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getBundleDeployments,
        variables: {
          projectId,
          releaseID,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getBundleDeployments.__typename === 'GetBundleDeploymentsSuccess') {
        return postData.data.getBundleDeployments.result;
      }
      return Promise.reject(new Error(postData.data.getBundleDeployments.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getBundleFileTypes({
    projectId,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getBundleFileTypes,
        variables: {
          projectId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getBundleFileTypes.__typename === 'GetBundleFileTypesSuccess') {
        return postData.data.getBundleFileTypes;
      }
      return Promise.reject(new Error(postData.data.getBundleFileTypes.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getMachineTelemetryConsumption(
    projectId, serialNumber, dateIni, dateEnd, limit, offset,
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getMachineTelemetryConsumption,
        variables: {
          projectId,
          serialNumber,
          dateIni,
          dateEnd,
          limit,
          offset,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getMachineTelemetryConsumption.__typename === 'GetMachineTelemetryConsumptionSuccess') {
        return postData.data.getMachineTelemetryConsumption;
      }
      const errorMessage = postData.data?.getMachineTelemetryConsumption.message || `${postData.data?.getMachineTelemetryConsumption?.statusCode}: ${postData.data.getMachineTelemetryConsumption?.__typename}`;
      return Promise.reject(new Error(errorMessage));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async createBundle(
    projectId, release,
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: createBundle,
        variables: {
          projectId, release,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.createBundle.__typename === 'CreateBundleSuccess') {
        return postData.data.createBundle.result;
      }
      return Promise.reject(new Error(postData.data.createBundle.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async updateBundle(projectId, releaseID, title, description) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: updateBundle,
        variables: {
          projectId, releaseID, title, description,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.updateBundle.__typename === 'UpdateBundleSuccess') {
        return postData.data.updateBundle.result;
      }
      return Promise.reject(new Error(postData.data.updateBundle.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getBrandConsumptions(
    projectId, filters, dateIni, dateEnd, limit, offset, searchByProcessedOnUtc,
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getBrandConsumptions,
        variables: {
          projectId,
          filters,
          dateIni,
          dateEnd,
          limit,
          offset,
          searchByProcessedOnUtc,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getBrandConsumptions.__typename === 'GetBrandConsumptionsSuccess') {
        return postData.data.getBrandConsumptions;
      }
      return Promise.reject(new Error(postData.data.getBrandConsumptions.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }


  static async getBrandConsumptionsCSV(
    projectId, filters, dateIni, dateEnd,
  ) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const postData = await API.graphql({
        query: getBrandConsumptionsCSV,
        variables: {
          projectId,
          filters,
          dateIni,
          dateEnd,
          user: userId,
          jwtToken: userAuth.signInUserSession.accessToken.jwtToken,
        },
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getBrandConsumptionsCSV.__typename === 'GetBrandConsumptionsCSVSuccess') {
        return postData.data.getBrandConsumptionsCSV;
      }
      return Promise.reject(new Error(postData.data.getBrandConsumptionsCSV.message));
    } catch (data) {
      console.error('error getBrandConsumptionsCSV', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors}`));
    }
  }

  static async getMachineTelemetryConsumptionCSV(
    projectId, serialNumber, dateIni, dateEnd,
  ) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const postData = await API.graphql({
        query: getMachineTelemetryConsumptionCSV,
        variables: {
          projectId,
          serialNumber,
          dateIni,
          dateEnd,
          user: userId,
          jwtToken: userAuth.signInUserSession.accessToken.jwtToken,
        },
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getMachineTelemetryConsumptionCSV.__typename === 'GetMachineTelemetryConsumptionCSVSuccess') {
        return postData.data.getMachineTelemetryConsumptionCSV;
      }
      return Promise.reject(new Error(`${postData.data.getMachineTelemetryConsumptionCSV.statusCode}: ${postData.data.getMachineTelemetryConsumptionCSV.__typename}`));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async uploadAssetsFromPackage(projectId, file) {
    // upload the zip file to the ALM S3 (alm-graphql-files-bucket-TARGET-REGION, configured in AWSExports) to be able to get it from ALM BE
    const success = await S3Service.uploadFile(file);
    if (!success) {
      return Promise.reject(new Error('Could not upload file to S3'));
    }
    try {
      const user = await Auth.currentAuthenticatedUser();
      const filePath = file.path;
      const postData = await API.graphql({
        query: uploadAssetsFromPackage,
        variables: {
          projectId,
          filePath,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        await S3Service.deleteFile(filePath);
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.uploadAssetsFromPackage.__typename === 'UploadAssetsFromPackageSuccess') {
        await S3Service.deleteFile(filePath);
        return postData.data.uploadAssetsFromPackage.list;
      }
      await S3Service.deleteFile(filePath);
      return Promise.reject(new Error(postData.data.uploadAssetsFromPackage.message));
    } catch (data) {
      await S3Service.deleteFile(file.path);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getTelemetryObject(
    projectId, object, queryParams, filters, dateIni, dateEnd, limit, offset, datesRange, searchByProcessedOnUtc,
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getTelemetryObject,
        variables: {
          projectId,
          object,
          queryParams,
          filters,
          dateIni,
          dateEnd,
          limit,
          offset,
          datesRange,
          searchByProcessedOnUtc,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getTelemetryObject.__typename === 'GetTelemetryObjectSuccess') {
        return postData.data.getTelemetryObject;
      }
      return Promise.reject(new Error(postData.data.getTelemetryObject.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getTelemetryObjectCSV(
    projectId, object, queryParams, filters, dateIni, dateEnd, datesRange,
  ) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const postData = await API.graphql({
        query: getTelemetryObjectCSV,
        variables: {
          projectId,
          object,
          queryParams,
          filters,
          dateIni,
          dateEnd,
          datesRange,
          user: userId,
          jwtToken: userAuth.signInUserSession.accessToken.jwtToken,
        },
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getTelemetryObjectCSV.__typename === 'GetTelemetryObjectCSVSuccess') {
        return postData.data.getTelemetryObjectCSV;
      }
      console.log('postData.data.getTelemetryObjectCSV', postData.data?.getTelemetryObjectCSV);
      return Promise.reject(new Error(postData.data.getTelemetryObjectCSV.message));
    } catch (data) {
      console.log('error in getTelemetryObjectCSV', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getLifeCycleObject(
    projectId, object, queryParams, filters, dateIni, dateEnd, paginationToken,
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getLifeCycleObject,
        variables: {
          projectId,
          object,
          queryParams,
          filters,
          dateIni,
          dateEnd,
          paginationToken,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getLifeCycleObject.__typename === 'GetLifeCycleObjectSuccess') {
        return postData.data.getLifeCycleObject;
      }
      return Promise.reject(new Error(postData.data.getLifeCycleObject.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getLifeCycleObjectPaginated(
    projectId, object, queryParams, filters, dateIni, dateEnd, page, pageSize,
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getLifeCycleObjectPaginated,
        variables: {
          projectId,
          object,
          queryParams,
          filters,
          dateIni,
          dateEnd,
          page,
          pageSize,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getLifeCycleObjectPaginated.__typename === 'GetLifeCycleObjectPaginatedSuccess') {
        return postData.data.getLifeCycleObjectPaginated;
      }
      return Promise.reject(new Error(postData.data.getLifeCycleObjectPaginated.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getSRFfunctions({ projectId }) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: getSRFfunctions,
      variables: {
        projectId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (!postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.getSRFfunctions.__typename === 'GetSRFfunctionsSuccess') {
      return postData.data?.getSRFfunctions;
    }
    return Promise.reject(new Error(postData.data.getSRFfunctions.message));
  }

  static async getSRFBackends({ projectId }) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: getSRFBackends,
      variables: {
        projectId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (!postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.getSRFBackends.__typename === 'GetSRFBackendsSuccess') {
      return postData.data?.getSRFBackends?.result;
    }
    return Promise.reject(new Error(postData.data.getSRFBackends.message));
  }

  static async executeSRF(
    projectId, machineId, functionName, securityMode, jwtToken,
  ) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: executeSRF,
      variables: {
        projectId,
        machineId,
        functionName,
        securityMode,
        jwtToken,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (!postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.executeSRF.__typename === 'ExecuteSRFSuccess') {
      return postData.data?.executeSRF;
    }
    return Promise.reject(new Error(postData.data.executeSRF.message));
  }

  static async cancelSRF(
    projectId, reqId,
  ) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: cancelSRF,
      variables: {
        projectId,
        reqId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });

    if (!postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.cancelSRF.__typename === 'CancelSRFSuccess') {
      return postData.data?.cancelSRF?.result;
    }
    return Promise.reject(new Error(postData.data.cancelSRF.message));
  }

  static async getLifeCycleObjectCSV(
    projectId, object, queryParams, filters, dateIni, dateEnd, datesRange,
  ) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const postData = await API.graphql({
        query: getLifeCycleObjectCSV,
        variables: {
          projectId,
          object,
          queryParams,
          filters,
          dateIni,
          dateEnd,
          datesRange,
          user: userId,
          jwtToken: userAuth.signInUserSession.accessToken.jwtToken,
        },
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getLifeCycleObjectCSV.__typename === 'GetLifeCycleObjectCSVSuccess') {
        return postData.data?.getLifeCycleObjectCSV;
      }
      return Promise.reject(new Error(postData.data.getLifeCycleObjectCSV.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getSandboxObject(
    projectId, object, queryParams, filters, dateIni, dateEnd, datesRange, paginationToken,
  ) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getSandboxObject,
        variables: {
          projectId,
          object,
          queryParams,
          filters,
          dateIni,
          dateEnd,
          datesRange,
          paginationToken,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getSandboxObject.__typename === 'GetSandboxObjectSuccess') {
        return postData.data.getSandboxObject;
      }
      return Promise.reject(new Error(postData.data.getSandboxObject.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getSandboxObjectCSV(
    projectId, object, queryParams, filters, dateIni, dateEnd, datesRange,
  ) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const postData = await API.graphql({
        query: getSandboxObjectCSV,
        variables: {
          projectId,
          object,
          queryParams,
          filters,
          dateIni,
          dateEnd,
          datesRange,
          user: userId,
          jwtToken: userAuth.signInUserSession.accessToken.jwtToken,
        },
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });
      console.log('Sandbox Object CSV Response:', postData);
      if (!postData?.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getSandboxObjectCSV.__typename === 'GetSandboxObjectCSVSuccess') {
        return postData.data.getSandboxObjectCSV;
      }
      console.log('Error generating CSV:', postData.data.getSandboxObjectCSV?.message);
      return Promise.reject(new Error(postData.data.getSandboxObjectCSV?.message));
    } catch (data) {
      console.log('Error generating CSV:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data?.errors}`));
    }
  }

  static async getPhysicalUsers() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getPhysicalUsers,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getPhysicalUsers.__typename === 'GetPhysicalUsersSuccess') {
        return postData.data.getPhysicalUsers.result;
      }
      return Promise.reject(new Error(postData.data.getPhysicalUsers.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getPhysicalUser(physicalUserId) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getPhysicalUser,
        variables: { physicalUserId },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getPhysicalUser.__typename === 'GetPhysicalUserSuccess') {
        return postData.data.getPhysicalUser.result;
      }
      return Promise.reject(new Error(postData.data.getPhysicalUser.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async createSerialDeploy(projectId, fileIDS, releaseID, type, value, comments, deployRegEx, stagedDeployment = false) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const variables = {
        projectId,
        fileIDS: fileIDS.length > 0 ? fileIDS : undefined,
        releaseID,
        type,
        value,
        comments,
        deployRegEx,
        user: userId,
        CanaryStage: stagedDeployment,
      };

      const postData = await API.graphql({
        query: createSerialDeploy,
        variables,
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });
      if (postData.data.createSerialDeploy.__typename === 'DeploymentOutputSuccess') {
        if (postData.data.createSerialDeploy?.statusCode) {
          return Promise.reject(postData.data.createSerialDeploy.message);
        }
        return postData.data.createSerialDeploy.deployResult;
      }
      return Promise.reject(new Error(postData.data.createSerialDeploy.message));
    } catch (data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
  }

  static async createMarketDeploy(projectId, fileIDS, releaseID, type, value, comments, deployRegEx, stagedDeployment = false) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const variables = {
        projectId,
        fileIDS: fileIDS.length > 0 ? fileIDS : undefined,
        releaseID,
        type,
        value,
        comments,
        deployRegEx,
        user: userId,
        CanaryStage: stagedDeployment,
      };

      const postData = await API.graphql({
        query: createMarketDeploy,
        variables,
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });
      if (postData.data.createMarketDeploy.__typename === 'DeploymentOutputSuccess') {
        if (postData.data.createMarketDeploy?.statusCode) {
          return Promise.reject(postData.data.createMarketDeploy.message);
        }
        return postData.data.createMarketDeploy.deployResult;
      }
      return Promise.reject(new Error(postData.data.createMarketDeploy.message));
    } catch (data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
  }

  static async createRegexDeploy(projectId, fileIDS, releaseID, type, value, comments, deployRegEx, stagedDeployment = false) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const variables = {
        projectId,
        fileIDS: fileIDS.length > 0 ? fileIDS : undefined,
        releaseID,
        type,
        value,
        comments,
        deployRegEx,
        user: userId,
        CanaryStage: stagedDeployment,
      };

      const postData = await API.graphql({
        query: createRegexDeploy,
        variables,
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });
      if (postData.data.createRegexDeploy.__typename === 'DeploymentOutputSuccess') {
        if (postData.data.createRegexDeploy?.statusCode) {
          return Promise.reject(postData.data.createRegexDeploy.message);
        }
        return postData.data.createRegexDeploy.deployResult;
      }
      return Promise.reject(new Error(postData.data.createRegexDeploy.message));
    } catch (data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
  }

  static async createGlobalDeploy(
    projectId,
    fileIDS,
    releaseID,
    type,
    value,
    comments,
    target,
    targetMarket,
    exclude,
    excludeMarket,
    stagedDeployment = false,
  ) {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      const userId = await getCurrentAuthenticatedUserId();
      const postData = await API.graphql({
        query: createGlobalDeploy,
        variables: {
          projectId,
          fileIDS: fileIDS.length > 0 ? fileIDS : undefined,
          releaseID,
          type,
          value,
          comments,
          deployRegEx: undefined,
          user: userId,
          target,
          targetMarket,
          exclude,
          excludeMarket,
          CanaryStage: stagedDeployment,
        },
        authToken: userAuth.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.createGlobalDeploy.__typename === 'DeploymentOutputSuccess') {
        return postData.data.createGlobalDeploy.deployResult;
      }
      return Promise.reject(new Error(postData.data.createGlobalDeploy.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async deleteDeploy(projectId, deployId) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteDeploy,
        variables: {
          projectId,
          deployId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        const errorMessage = postData.errors?.[0]?.message || 'Internal Server Error';
        return Promise.reject(new Error(errorMessage));
      }
      if (postData.data.deleteDeploy.__typename === 'DeleteDeploySuccess') {
        return postData.data.deleteDeploy.response;
      }
      // Handle error types: NotFound, BadRequest, InternalServerError, Forbidden
      const errorData = postData.data.deleteDeploy;
      return Promise.reject(new Error(errorData.message || 'Unknown error'));
    } catch (data) {
      const errorMessage = data?.errors?.[0]?.message || data?.message || 'Internal Server Error';
      return Promise.reject(new Error(errorMessage));
    }
  }

  static async updateDeployment(projectId, deployId, requestBody) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: updateDeployment,
        variables: {
          projectId,
          deployId,
          requestBody,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data || !postData.data.updateDeployment) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.updateDeployment.__typename === 'UpdateDeploymentSuccess') {
        return postData.data.updateDeployment.result;
      }
      return Promise.reject(new Error(postData.data.updateDeployment.message));
    } catch (data) {
      const message = data?.errors?.[0]?.message || data?.message || 'Unknown error';
      return Promise.reject(new Error(`Internal Server Error: ${message}`));
    }
  }

  static async deleteBundle(projectId, releaseID) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteBundle,
        variables: {
          projectId,
          releaseID,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.deleteBundle.__typename === 'DeleteBundleSuccess') {
        return postData.data.deleteBundle.response;
      }
      return Promise.reject(new Error(postData.data.deleteBundle.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async deleteAsset(projectId, deleteAssetInput) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteAsset,
        variables: {
          projectId,
          deleteAssetInput,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.deleteAsset.__typename === 'DeleteAssetSuccess') {
        return postData.data.deleteAsset.response;
      }
      return Promise.reject(new Error(postData.data.deleteAsset.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async updateAssetDescription(projectId, fileId, assetDescription) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const result = await API.graphql({
        query: updateAssetDescription,
        variables: {
          projectId,
          fileId,
          assetDescription,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (result.errors || !result.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (result.data.updateAssetDescription.__typename === 'UpdateAssetDescriptionSuccess') {
        return result.data.updateAssetDescription.response;
      }
      return Promise.reject(new Error(result.data.updateAssetDescription.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getNotifications({
    user,
  }) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getNotifications,
        variables: {
          user,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getNotifications.__typename === 'NotificationsSuccess') {
        return postData.data.getNotifications.notifications;
      }
      return Promise.reject(new Error(postData.data.getNotifications.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getConfig() {
    try {
      const postData = await API.graphql({
        query: getConfig,
        authToken: 'auth',
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getConfig.__typename === 'GetConfigSuccess') {
        return postData.data.getConfig.data;
      }
      return Promise.reject(new Error(postData.data.getConfig.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getUnreadNotificationsCount({
    user,
  }) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getUnreadNotificationsCount,
        variables: {
          user,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getUnreadNotificationsCount.__typename === 'UnreadNotificationsCountSuccess') {
        return postData.data.getUnreadNotificationsCount.count;
      }
      return Promise.reject(new Error(postData.data.getUnreadNotificationsCount.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getUnreadNotifications({
    user,
  }) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getUnreadNotifications,
        variables: {
          user,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getNotifications.__typename === 'NotificationsSuccess') {
        return postData.data.getNotifications.notifications;
      }
      return Promise.reject(new Error(postData.data.getNotifications.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async createNotification(email, notificationTitle, notificationDescription, notificationType = 'info') {
    try {
      const userToken = await Auth.currentAuthenticatedUser();

      const variables = {
        title: notificationTitle,
        description: notificationDescription,
        user: email,
        type: notificationType,
        userEmail: email,
        jwtToken: userToken.signInUserSession.accessToken.jwtToken,
      };

      const postData = await API.graphql({
        query: createNotification,
        variables,
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.createNotification.__typename === 'NotificationSuccess') {
        return postData.data.createNotification.notification;
      }
      return Promise.reject(new Error(postData.data.createNotification.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async deleteNotificationsByTitle(title) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteNotificationsByTitle,
        variables: {
          title,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.deleteNotificationsByTitle.__typename === 'DeleteNotificationSuccess') {
        return postData.data.deleteNotificationsByTitle.response;
      }
      return Promise.reject(new Error(postData.data.deleteNotificationsByTitle.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async markAsReadMutation(id) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: markAsReadMutation,
        variables: {
          id,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.markAsRead.__typename === 'MarkNotificationSuccess') {
        return postData.data.markAsRead.response;
      }
      return Promise.reject(new Error(postData.data.markAsRead.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async updateConfig(config) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: updateConfig,
        variables: {
          config,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.updateConfig.__typename === 'UpdateConfigSuccess') {
        return postData.data.updateConfig.response;
      }
      return Promise.reject(new Error(postData.data.updateConfig.message));
    } catch (err) {
      return Promise.reject(new Error(`Internal Server Error: ${err.errors[0].message}`));
    }
  }

  static async deleteNotification(id) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteNotification,
        variables: {
          id,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.deleteNotification.__typename === 'DeleteNotificationSuccess') {
        return postData.data.deleteNotification.response;
      }
      return Promise.reject(new Error(postData.data.deleteNotification.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors[0].message}`));
    }
  }

  static async getSRFToken({
    privateKey,
    payload,
    algorithm,
  }) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getSRFToken,
        variables: {
          privateKey,
          payload,
          algorithm,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getSRFToken.__typename === 'GetSRFTokenSuccess') {
        return postData.data.getSRFToken.result;
      }
      return Promise.reject(new Error(postData.data.getSRFToken.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getSRFRequests({
    projectId, machineId,
  }) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getSRFRequests,
        variables: {
          projectId,
          machineId,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getSRFRequests.__typename === 'GetSRFRequestsSuccess') {
        return postData.data.getSRFRequests.result;
      }
      return Promise.reject(new Error(postData.data.getSRFRequests.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getSRFRequest({
    projectId, reqId,
  }) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getSRFRequest,
        variables: {
          projectId,
          reqId,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getSRFRequest.__typename === 'GetSRFRequestSuccess') {
        return postData.data.getSRFRequest.result;
      }
      return Promise.reject(new Error(postData.data.getSRFRequest.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getCertificateQuota(
    awsUserId,
  ) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getCertificateQuota,
        variables: {
          awsUserId,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        console.error('Error getCertificateQuota: ', postData.errors);
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getCertificateQuota.__typename === 'GetCertificateQuotaSuccess') {
        return postData.data.getCertificateQuota.result;
      }
      return Promise.reject(new Error(postData.data.getCertificateQuota.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async getCertificateStatus(certificateId) {
    try {
      const userToken = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getCertificateStatus,
        variables: {
          certificateId,
        },
        authToken: userToken.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data || postData.data?.getCertificateStatus?.statusCode === 500) {
        console.error('Error getCertificateStatus: ', postData.errors);
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getCertificateStatus.__typename === 'GetCertificateStatusSuccess') {
        return postData.data.getCertificateStatus.result;
      }
      return Promise.reject(new Error(postData.data.getCertificateStatus.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data}`));
    }
  }

  static async deleteWave(projectId, waveID) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteWave,
        variables: {
          projectId,
          waveID,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.deleteWave.__typename === 'DeleteWaveSuccess') {
        return postData.data.deleteWave.result;
      }

      return Promise.reject(new Error(postData.data.deleteWave.message));
    } catch (data) {
      console.error('Error in deleteWave:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async updateWave(projectId, waveID, waveDescription, wavePaused, canaryStage) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const variables = {
        projectId,
        waveID,
        canaryStage
      };
      
      // Add waveDescription if provided
      if (waveDescription !== undefined && waveDescription !== null) {
        variables.waveDescription = waveDescription;
      }
      
      // Add wavePaused if provided
      if (wavePaused !== undefined && wavePaused !== null) {
        variables.wavePaused = wavePaused;
      }

      if (canaryStage !== undefined && canaryStage !== null) {
        variables.canaryStage = canaryStage;
      }
      
      console.log('updateWaveObject variables:', variables);
      
      const postData = await API.graphql({
        query: updateWaveObject,
        variables,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      console.log('updateWaveObject response:', postData);

      if (postData.errors || !postData.data) {
        console.error('updateWaveObject errors or no data:', postData.errors);
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (!postData.data.updateWaveObject) {
        console.error('updateWaveObject returned null', postData);
        return Promise.reject(new Error('Update wave returned null response'));
      }

      if (postData.data.updateWaveObject.__typename === 'UpdateWaveSuccess') {
        return postData.data.updateWaveObject.result;
      }

      return Promise.reject(new Error(postData.data.updateWaveObject.message));
    } catch (data) {
      console.error('Error in updateWaveObject:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getWaveById(projectId, waveID) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getWaveById,
        variables: {
          projectId,
          waveID,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getWaveById.__typename === 'GetWaveByIdSuccess') {
        return postData.data.getWaveById.result;
      }

      return Promise.reject(new Error(postData.data.getWaveById.message));
    } catch (data) {
      console.error('Error in getWaveById:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async listPaginatedWaves({
    projectId,
    page,
    pageSize,
    sortDirection,
    datetimeFrom,
    datetimeTo,
    waveDescriptionKey,
    waveDescriptionValue,
    fileType,
    fileID,
    releaseID,
    deployID,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: listPaginatedWaves,
        variables: {
          projectId,
          page,
          pageSize,
          sortDirection,
          datetimeFrom,
          datetimeTo,
          waveDescriptionKey,
          waveDescriptionValue,
          fileType,
          fileID,
          releaseID,
          deployID,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.listPaginatedWaves.__typename === 'ListPaginatedWavesSuccess') {
        return postData.data.listPaginatedWaves;
      }

      return Promise.reject(new Error(postData.data.listPaginatedWaves.message));
    } catch (data) {
      console.error('Error in listPaginatedWaves:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async onboardingDevice({
    projectId,
    serialNumber,
    topicNumber,
    payload,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: onboardingDevice,
        variables: {
          projectId,
          serialNumber,
          topicNumber,
          payload,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.onboardingDevice.__typename === 'OnboardingDeviceSuccess') {
        return postData.data.onboardingDevice.result;
      }

      return Promise.reject(new Error(postData.data.onboardingDevice.message));
    } catch (data) {
      console.error('Error in onboardingDevice:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async subscribeToTopic({
    projectId,
    serialNumber,
    topicNumber,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: subscribeToTopic,
        variables: {
          projectId,
          serialNumber,
          topicNumber,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.subscribeToTopic.__typename === 'SubscribeToTopicSuccess') {
        return postData.data.subscribeToTopic.result;
      }

      return Promise.reject(new Error(postData.data.subscribeToTopic.message));
    } catch (data) {
      console.error('Error in subscribeToTopic:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getIotMessages({
    projectId,
    serialNumber,
    topicNumber,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getIotMessages,
        variables: {
          projectId,
          serialNumber,
          topicNumber,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getIotMessages.__typename === 'GetIotMessagesSuccess') {
        return postData.data.getIotMessages.result;
      }

      return Promise.reject(new Error(postData.data.getIotMessages.message));
    } catch (data) {
      console.error('Error in getIotMessages:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getDevicesPermissionsByProject(projectId) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getDevicesPermissionsByProject,
        variables: {
          projectId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getDevicesPermissionsByProject.__typename === 'GetDevicesPermissionsByProjectSuccess') {
        return postData.data.getDevicesPermissionsByProject.result;
      }

      return Promise.reject(new Error(postData.data.getDevicesPermissionsByProject.message));
    } catch (data) {
      console.error('Error in getDevicesPermissionsByProject:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async createDevicePermission(projectId, device) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: createDevicePermission,
        variables: {
          projectId,
          device,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.createDevicePermission.__typename === 'CreateDevicePermissionSuccess') {
        return postData.data.createDevicePermission.result;
      }

      return Promise.reject(new Error(postData.data.createDevicePermission.message));
    } catch (data) {
      console.error('Error in createDevicePermission:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async deleteDevicePermission(projectId, device) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteDevicePermission,
        variables: {
          projectId,
          device,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.deleteDevicePermission.__typename === 'DeleteDevicePermissionSuccess') {
        return postData.data.deleteDevicePermission.result;
      }

      return Promise.reject(new Error(postData.data.deleteDevicePermission.message));
    } catch (data) {
      console.error('Error in deleteDevicePermission:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async deleteAllDevicesPermissions(projectId) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const devicesPermissions = await this.getDevicesPermissionsByProject(projectId);

      const deletePromises = devicesPermissions.map((device) => this.deleteDevicePermission(projectId, device));

      await Promise.all(deletePromises);
      return { success: true };
    } catch (error) {
      console.error('Error in deleteAllDevicesPermissions:', error);
      return Promise.reject(new Error(`Internal Server Error: ${error.message}`));
    }
  }

  static async getDeviceConnectivityStatus({ projectId, serialNumber }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getDeviceConnectivityStatus,
        variables: {
          projectId,
          serialNumber,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getDeviceConnectivityStatus.__typename === 'GetDeviceConnectivityStatusSuccess') {
        return postData.data.getDeviceConnectivityStatus.result;
      }

      return Promise.reject(new Error(postData.data.getDeviceConnectivityStatus.message));
    } catch (data) {
      console.error('Error in getDeviceConnectivityStatus:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getDeviceConnectivityStatusHistory({
    projectId, serialNumber, from, to, paginationToken,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getDeviceConnectivityStatusHistory,
        variables: {
          projectId,
          serialNumber,
          from,
          to,
          paginationToken,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getDeviceConnectivityStatusHistory.__typename === 'GetDeviceConnectivityStatusHistorySuccess') {
        return postData.data.getDeviceConnectivityStatusHistory.result;
      }

      return Promise.reject(new Error(postData.data.getDeviceConnectivityStatusHistory.message));
    } catch (data) {
      console.error('Error in getDeviceConnectivityStatusHistory:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getDeviceHistory({ projectId, serialNumber, from, to, limit, pageNumber }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getDeviceHistory,
        variables: { projectId, serialNumber, from, to, limit, pageNumber },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) return Promise.reject(new Error('Internal Server Error'));
      if (postData.data.getDeviceHistory.__typename === 'GetDeviceHistorySuccess') return postData.data.getDeviceHistory.result;
      return Promise.reject(new Error(postData.data.getDeviceHistory.message));
    } catch (data) {
      console.error('Error in getDeviceHistory:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getGatewayHistory({ projectId, serialNumber, gatewaySerial, from, to, limit, pageNumber }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getGatewayHistory,
        variables: { projectId, serialNumber, gatewaySerial, from, to, limit, pageNumber },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) return Promise.reject(new Error('Internal Server Error'));
      if (postData.data.getGatewayHistory.__typename === 'GetGatewayHistorySuccess') return postData.data.getGatewayHistory.result;
      return Promise.reject(new Error(postData.data.getGatewayHistory.message));
    } catch (data) {
      console.error('Error in getGatewayHistory:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getModuleHistory({ projectId, serialNumber, moduleSerial, from, to, limit, pageNumber }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getModuleHistory,
        variables: { projectId, serialNumber, moduleSerial, from, to, limit, pageNumber },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) return Promise.reject(new Error('Internal Server Error'));
      if (postData.data.getModuleHistory.__typename === 'GetModuleHistorySuccess') return postData.data.getModuleHistory.result;
      return Promise.reject(new Error(postData.data.getModuleHistory.message));
    } catch (data) {
      console.error('Error in getModuleHistory:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getDeviceSnapHistory({ projectId, serialNumber, from, to, limit, pageNumber }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getDeviceSnapHistory,
        variables: { projectId, serialNumber, from, to, limit, pageNumber },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) return Promise.reject(new Error('Internal Server Error'));
      if (postData.data.getDeviceSnapHistory.__typename === 'GetDeviceSnapHistorySuccess') return postData.data.getDeviceSnapHistory.result;
      return Promise.reject(new Error(postData.data.getDeviceSnapHistory.message));
    } catch (data) {
      console.error('Error in getDeviceSnapHistory:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getModuleSnapHistory({ projectId, serialNumber, moduleSerial, from, to, limit, pageNumber }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getModuleSnapHistory,
        variables: { projectId, serialNumber, moduleSerial, from, to, limit, pageNumber },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) return Promise.reject(new Error('Internal Server Error'));
      if (postData.data.getModuleSnapHistory.__typename === 'GetModuleSnapHistorySuccess') return postData.data.getModuleSnapHistory.result;
      return Promise.reject(new Error(postData.data.getModuleSnapHistory.message));
    } catch (data) {
      console.error('Error in getModuleSnapHistory:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getShadowState({ projectId, serialNumber }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getShadowState,
        variables: {
          projectId,
          serialNumber,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getShadowState.__typename === 'GetShadowStateSuccess') {
        return {
          ...postData.data.getShadowState.result,
          reported: postData.data.getShadowState.result?.reported ? JSON.parse(postData.data.getShadowState.result.reported) : {}
        }
      }
      return Promise.reject(new Error(postData.data.getShadowState.message));
    } catch (data) {
      console.error('Error in getShadowState:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getNewUsersBetweenDates(from, to) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getNewUsersBetweenDates,
        variables: {
          from,
          to,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getNewUsersBetweenDates.__typename === 'GetNewUsersBetweenDatesSuccess') {
        return postData.data.getNewUsersBetweenDates.result;
      }

      return Promise.reject(new Error(postData.data.getNewUsersBetweenDates.message));
    } catch (data) {
      console.error('Error in getNewUsersBetweenDates:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getLastUsersAction() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getLastUsersAction,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getLastUsersAction.__typename === 'GetLastUsersActionSuccess') {
        return postData.data.getLastUsersAction.result;
      }

      return Promise.reject(new Error(postData.data.getLastUsersAction.message));
    } catch (data) {
      console.error('Error in getLastUsersAction:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getUsersFromCognito() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getUsersFromCognito,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getUsersFromCognito.__typename === 'GetUsersFromCognitoSuccess') {
        return postData.data.getUsersFromCognito.result;
      }

      return Promise.reject(new Error(postData.data.getUsersFromCognito.message));
    } catch (data) {
      console.error('Error in getUsersFromCognito:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getAnonymousQuickSightUrl(namespace, dashboardId, projectsCode) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getAnonymousQuickSightUrl,
        variables: {
          namespace,
          dashboardId,
          projectsCode,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getAnonymousQuickSightUrl.__typename === 'GetAnonymousQuickSightUrlSuccess') {
        return postData.data.getAnonymousQuickSightUrl;
      }

      return Promise.reject(new Error(postData.data.getAnonymousQuickSightUrl.message));
    } catch (data) {
      console.error('Error in getAnonymousQuickSightUrl:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getCognitoUsersByEmail(email) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getCognitoUsersByEmail,
        variables: {
          email,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        console.error("Error in getCognitoUsersByEmail API call:", postData.errors);
        return Promise.reject(new Error(postData.errors ? postData.errors[0].message : 'Internal Server Error'));
      }
      return postData.data.getCognitoUsersByEmail;
    } catch (data) {
      console.error("Exception in getCognitoUsersByEmail:", data);
      return Promise.reject(new Error(data.message || 'Internal Server Error during getCognitoUsersByEmail'));
    }
  }

  static async getCognitoUsersFiltered({ searchText, project, role } = {}) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getCognitoUsersFiltered,
        variables: {
          searchText: searchText || null,
          project: project || null,
          role: role || null,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error(postData.errors ? postData.errors[0].message : 'Internal Server Error'));
      }
      if (postData.data.getCognitoUsersFiltered.__typename === 'GetCognitoUsersFilteredSuccess') {
        return postData.data.getCognitoUsersFiltered;
      }
      return Promise.reject(new Error(postData.data.getCognitoUsersFiltered.message || 'Error fetching filtered users'));
    } catch (data) {
      return Promise.reject(new Error(data.message || 'Internal Server Error during getCognitoUsersFiltered'));
    }
  }

  static async createCognitoUser(email, password) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: createCognitoUser,
        variables: {
          email,
          password,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error(postData.errors ? postData.errors[0].message : 'Unknown error'));
      }
      if (postData.data.createCognitoUser.__typename === 'BadRequest') {
        return Promise.reject(new Error(postData.data.createCognitoUser.message));
      }

      if (postData.data.createCognitoUser.__typename === 'CreateCognitoUserSuccess') {
        return postData.data.createCognitoUser.result;
      }
      return Promise.reject(new Error(postData.data.createCognitoUser));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message || data}`));
    }
  }

  static async deleteCognitoUserByUserId(userId) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteCognitoUserByUserId,
        variables: {
          userId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.deleteCognitoUserByUserId.__typename === 'DeleteCognitoUserByUserIdSuccess') {
        return postData.data.deleteCognitoUserByUserId.result;
      }
      return Promise.reject(new Error(postData.data.deleteCognitoUserByUserId.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data}`));
    }
  }

  static async deleteMyAccount() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deleteMyAccount,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.deleteMyAccount.__typename === 'DeleteMyAccountSuccess') {
        return postData.data.deleteMyAccount.result;
      }
      return Promise.reject(new Error(postData.data.deleteMyAccount.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data}`));
    }
  }

  static async addGroupToUser(userId, group) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: addGroupToUser,
        variables: {
          userId,
          group,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.addGroupToUser.__typename === 'AddGroupToUserSuccess') {
        return postData.data.addGroupToUser.response;
      }
      return Promise.reject(new Error(postData.data.addGroupToUser.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data}`));
    }
  }

  static async removeGroupFromUser(userId, group) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: removeGroupFromUser,
        variables: {
          userId,
          group,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.removeGroupFromUser.__typename === 'RemoveGroupFromUserSuccess') {
        return postData.data.removeGroupFromUser.result;
      }
      return Promise.reject(new Error(postData.data.removeGroupFromUser.message));
    } catch (data) {
      return Promise.reject(new Error(data.errors ? data.errors[0].message : data.message || 'Internal Server Error'));
    }
  }

  static async checkGroupExists(groupName) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: checkGroupExists,
        variables: {
          groupName,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.checkGroupExists.__typename === 'CheckGroupExistsSuccess') {
        return postData.data.checkGroupExists.result;
      }
      return Promise.reject(new Error(postData.data.checkGroupExists.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message || data}`));
    }
  }

  static async createCognitoGroup(groupName) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: createCognitoGroup,
        variables: {
          groupName,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.createCognitoGroup.__typename === 'CreateCognitoGroupSuccess') {
        return postData.data.createCognitoGroup.result;
      }
      return Promise.reject(new Error(postData.data.createCognitoGroup.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message || data}`));
    }
  }

  static async getCongitoUsersPaginated(paginationToken, pageSize) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getCongitoUsersPaginated,
        variables: {
          paginationToken,
          pageSize,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        const errorMessage = postData.errors ? postData.errors[0].message : 'No data returned';
        return Promise.reject(new Error(errorMessage));
      }

      if (postData.data.getCognitoUsersPaginated.__typename === 'GetCognitoUsersPaginatedSuccess') {
        return postData.data.getCognitoUsersPaginated;
      }
      return Promise.reject(new Error(postData.data.getCognitoUsersPaginated.message));
    } catch (data) {
      const errorMessage = data.errors ? data.errors[0].message : data.message || 'Internal Server Error';
      return Promise.reject(new Error(`Error fetching paginated users: ${errorMessage}`));
    }
  }

  static async updateUserLastLoginDate(username) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (!user?.signInUserSession?.accessToken?.jwtToken) return undefined;
      const postData = await API.graphql({
        query: UPDATE_USER_LAST_LOGIN_DATE,
        variables: { username },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.updateUserLastLoginDate.__typename === 'UpdateUserLastLoginDateSuccess') {
        return postData.data.updateUserLastLoginDate.result;
      }
      return Promise.reject(new Error(postData.data.updateUserLastLoginDate.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message || data}`));
    }
  }

  static async createNewCredential({
    projects, name, quota, alertThreshold, iPWhiteList, pointOfContact, description, templateIds
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: createNewCredential,
        variables: {
          projects,
          name,
          quota,
          alertThreshold,
          iPWhiteList,
          pointOfContact,
          description,
          templateIds
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.createNewCredential.__typename === 'CreateNewCredentialSuccess') {
        return postData.data.createNewCredential.result;
      }
      return Promise.reject(new Error(postData.data.createNewCredential.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message || data}`));
    }
  }

  static async getTemplates() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getTemplates,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.getTemplates.__typename === 'GetTemplatesSuccess') {
        return postData.data.getTemplates.result || [];
      }
      return Promise.reject(new Error(postData.data.getTemplates.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message || data}`));
    }
  }

  static async getAuditLogs({
    limit, page, from, to, entity, entity_id, user_name, // eslint-disable-line camelcase
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getAuditLogs,
        variables: {
          limit, page, from, to, entity, entity_id, user_name, // eslint-disable-line camelcase
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error(postData.errors ? postData.errors[0].message : 'Failed to retrieve audit logs'));
      }
      if (postData.data.getAuditLogs.__typename === 'GetAuditLogsSuccess') {
        return postData.data.getAuditLogs;
      }
      return Promise.reject(new Error(postData.data.getAuditLogs.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async createAuditLog({
    entity, entity_id, change, detail, value, user_id, user_name, // eslint-disable-line camelcase
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: createAuditLog,
        variables: {
          entity, entity_id, change, detail, value, user_id, user_name, // eslint-disable-line camelcase
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (postData.errors || !postData.data) {
        return Promise.reject(new Error(postData.errors ? postData.errors[0].message : 'Failed to create audit log'));
      }
      if (postData.data.createAuditLog.__typename === 'CreateAuditLogSuccess') {
        return postData.data.createAuditLog;
      }
      return Promise.reject(new Error(postData.data.createAuditLog.message));
    } catch (data) {
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async updateCertificateQuota(awsUserId, amount, threshold) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: updateCertificateQuota,
        variables: { awsUserId, amount, threshold },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        const errorMessage = postData.errors ? postData.errors[0].message : 'Internal Server Error';
        return Promise.reject(new Error(errorMessage));
      }

      const result = postData.data.updateCertificateQuota;
      if (result.__typename === 'UpdateCertificateQuotaSuccess') {
        return result;
      }
      return Promise.reject(new Error(result.message || `${result.statusCode}: ${result.__typename}`));
    } catch (data) {
      const errorMessage = data.errors ? data.errors[0].message : data.message || 'Internal Server Error';
      console.error('Error in updateCertificateQuota:', data);
      return Promise.reject(new Error(`Internal Server Error: ${errorMessage}`));
    }
  }

  static async disablePhysicalUser(userId) {

    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: disablePhysicalUser,
      variables: {
        userId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.disablePhysicalUser.__typename === 'DisablePhysicalUserSuccess') {
      return postData.data.disablePhysicalUser.result;
    }
    return Promise.reject(new Error(postData.data.disablePhysicalUser.message));
  }

  static async enablePhysicalUser(userId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: enablePhysicalUser,
      variables: {
        userId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.enablePhysicalUser.__typename === 'EnablePhysicalUserSuccess') {
      return postData.data.enablePhysicalUser.result;
    }
    return Promise.reject(new Error(postData.data.enablePhysicalUser.message));
  }

  static async getPhysicalUserTemplates(physicalUserId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: getPhysicalUserTemplates,
      variables: {
        physicalUserId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.getPhysicalUserTemplates.__typename === 'GetPhysicalUserTemplatesSuccess') {
      return postData.data.getPhysicalUserTemplates.result || [];
    }
    return Promise.reject(new Error(postData.data.getPhysicalUserTemplates.message));
  }

  static async attachTemplateToPhysicalUser(physicalUserId, templateId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: attachTemplateToPhysicalUser,
      variables: {
        physicalUserId,
        templateId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.attachTemplateToPhysicalUser.__typename === 'AttachTemplateSuccess') {
      return postData.data.attachTemplateToPhysicalUser.result;
    }
    return Promise.reject(new Error(postData.data.attachTemplateToPhysicalUser.message));
  }

  static async detachTemplateFromPhysicalUser(physicalUserId, templateId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: detachTemplateFromPhysicalUser,
      variables: {
        physicalUserId,
        templateId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.detachTemplateFromPhysicalUser.__typename === 'DetachTemplateSuccess') {
      return postData.data.detachTemplateFromPhysicalUser.result;
    }
    return Promise.reject(new Error(postData.data.detachTemplateFromPhysicalUser.message));
  }

  static async rotateCredential(physicalUserId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: rotateCredential,
      variables: {
        physicalUserId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.rotateCredential.__typename === 'RotateCredentialSuccess') {
      return postData.data.rotateCredential.result;
    }
    return Promise.reject(new Error(postData.data.rotateCredential.message));
  }

  // Feature 032 - update a logical user's GPG public key
  static async updateLogicalUserGpgKey(userName, publicKey) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: updateLogicalUserGpgKey,
      variables: {
        userName,
        publicKey,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.updateLogicalUserGpgKey.__typename === 'UpdateLogicalUserGpgKeySuccess') {
      return postData.data.updateLogicalUserGpgKey;
    }
    return Promise.reject(new Error(postData.data.updateLogicalUserGpgKey.message));
  }

  // Feature 032 - rotate all physical users linked to a logical user
  static async rotateLinkedCredentials(physicalUserIds) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: rotateLinkedCredentials,
      variables: {
        physicalUserIds,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.rotateLinkedCredentials.__typename === 'RotateLinkedCredentialsSuccess') {
      return postData.data.rotateLinkedCredentials.results;
    }
    return Promise.reject(new Error(postData.data.rotateLinkedCredentials.message));
  }

  static async deleteAccessKeys(physicalUserId, accessKeyId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: deleteAccessKeys,
      variables: {
        physicalUserId,
        accessKeyId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.deleteAccessKeys.__typename === 'DeleteAccessKeysSuccess') {
      return postData.data.deleteAccessKeys;
    }
    return Promise.reject(new Error(postData.data.deleteAccessKeys.message));
  }

  static async deletePhysicalUserPermanent(physicalUserId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: deletePhysicalUserMutation,
      variables: {
        physicalUserId,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.deletePhysicalUser.__typename === 'DeletePhysicalUserSuccess') {
      return postData.data.deletePhysicalUser;
    }
    return Promise.reject(new Error(postData.data.deletePhysicalUser.message));
  }


  static async getDeviceInfo({ projectId, serialNumber }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getDeviceInfo,
        variables: {
          projectId,
          serialNumber,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (postData.data.getDeviceInfo.__typename === 'GetDeviceInfoSuccess') {
        return postData.data.getDeviceInfo.result;
      }

      return Promise.reject(new Error(postData.data.getDeviceInfo.message));
    } catch (data) {
      console.error('Error in getDeviceInfo:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async getCandidates(params, abortSignal = null) {
    try {
      // Check if request was already aborted before starting
      if (abortSignal && abortSignal.aborted) {
        const abortError = new Error('Request cancelled');
        abortError.name = 'AbortError';
        throw abortError;
      }

      const user = await Auth.currentAuthenticatedUser();
      
      // Only include parameters that are provided and not empty
      const variables = {
        projectId: params.projectId,
      };
      
      // Add fileId, releaseID, or fileIDs
      if (params.fileId) {
        variables.fileId = params.fileId;
      }
      if (params.releaseID) {
        variables.releaseID = params.releaseID;
      }
      if (params.fileIDs && params.fileIDs.length > 0) {
        variables.fileIDs = params.fileIDs;
      }
      
      // Only add optional parameters if they exist and have values
      if (params.targetMarket && params.targetMarket.length > 0) {
        variables.targetMarket = params.targetMarket;
      }
      if (params.excludeMarket && params.excludeMarket.length > 0) {
        variables.excludeMarket = params.excludeMarket;
      }
      if (params.target && params.target.trim() !== '') {
        variables.target = params.target;
      }
      if (params.targets && params.targets.length > 0) {
        variables.targets = params.targets;
      }
      if (params.exclude && params.exclude.length > 0) {
        variables.exclude = params.exclude;
      }
      if (params.targetRegex && params.targetRegex.length > 0) {
        variables.targetRegex = params.targetRegex;
      }
      if (params.excludeRegex && params.excludeRegex.length > 0) {
        variables.excludeRegex = params.excludeRegex;
      }
      
      // Check if request was aborted during variable setup
      if (abortSignal && abortSignal.aborted) {
        const abortError = new Error('Request cancelled');
        abortError.name = 'AbortError';
        throw abortError;
      }
      
      console.log('[getCandidates] Making GraphQL call with variables:', JSON.stringify(variables, null, 2));
      
      const postData = await API.graphql({
        query: getCandidates,
        variables,
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      // Check if request was aborted during GraphQL call
      if (abortSignal && abortSignal.aborted) {
        const abortError = new Error('Request cancelled');
        abortError.name = 'AbortError';
        throw abortError;
      }

      console.log('[getCandidates] GraphQL response:', JSON.stringify(postData, null, 2));

      if (postData.errors || !postData.data) {
        console.error('[getCandidates] GraphQL errors:', postData.errors);
        return Promise.reject(new Error('Internal Server Error'));
      }

      if (!postData.data.getCandidates) {
        return Promise.reject(new Error('getCandidates returned null'));
      }

      if (postData.data.getCandidates.__typename === 'GetCandidatesSuccess') {
        return postData.data.getCandidates.result;
      }

      return Promise.reject(new Error(postData.data.getCandidates.message));
    } catch (data) {
      // Re-throw AbortError as-is
      if (data.name === 'AbortError') {
        throw data;
      }
      console.error('Error in getCandidates:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors ? data.errors[0].message : data.message}`));
    }
  }

  static async updateLogicalUser(userName, userId, physicalUserId, iPWhiteList, pointOfContact, description, alertThreshold, brands) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: updateLogicalUser,
        variables: { userName, userId, physicalUserId, iPWhiteList, pointOfContact, description, alertThreshold, brands },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (postData.errors || !postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.updateLogicalUser.__typename === 'UpdateLogicalUserSuccess') {
        return {
          result: postData.data.updateLogicalUser.result,
          changeIds: postData.data.updateLogicalUser.changeIds || [],
        };
      }
      return Promise.reject(new Error(postData.data.updateLogicalUser.message));
    } catch (error) {
      return Promise.reject(new Error(`Internal Server Error: ${error.message}`));
    }
  }

  // Feature 027 - check IAM propagation status of a change request (e.g. a Brands update).
  static async getChangeRequestStatus(changeId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: getChangeRequestStatus,
      variables: { changeId },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.getChangeRequestStatus.__typename === 'GetChangeRequestStatusSuccess') {
      return postData.data.getChangeRequestStatus;
    }
    return Promise.reject(new Error(postData.data.getChangeRequestStatus.message));
  }

  // Feature 031 - Manage Policy Templates
  static async getPolicyTemplateDetails(templateId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: getPolicyTemplateDetails,
      variables: { templateId },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.getPolicyTemplateDetails.__typename === 'GetPolicyTemplateDetailsSuccess') {
      return postData.data.getPolicyTemplateDetails.result;
    }
    return Promise.reject(new Error(postData.data.getPolicyTemplateDetails.message));
  }

  static async createPolicyTemplate(description, services, readOnly, permission) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: createPolicyTemplate,
      variables: { description, services, readOnly, permission },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.createPolicyTemplate.__typename === 'CreatePolicyTemplateSuccess') {
      return { result: postData.data.createPolicyTemplate.result, changeIds: postData.data.createPolicyTemplate.changeIds || [] };
    }
    return Promise.reject(new Error(postData.data.createPolicyTemplate.message));
  }

  static async updatePolicyTemplate(templateId, description, services, readOnly, permission) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: updatePolicyTemplate,
      variables: {
        templateId, description, services, readOnly, permission,
      },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.updatePolicyTemplate.__typename === 'UpdatePolicyTemplateSuccess') {
      return { result: postData.data.updatePolicyTemplate.result, changeIds: postData.data.updatePolicyTemplate.changeIds || [] };
    }
    return Promise.reject(new Error(postData.data.updatePolicyTemplate.message));
  }

  static async deletePolicyTemplate(templateId) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: deletePolicyTemplate,
      variables: { templateId },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.deletePolicyTemplate.__typename === 'DeletePolicyTemplateSuccess') {
      return postData.data.deletePolicyTemplate.result;
    }
    return Promise.reject(new Error(postData.data.deletePolicyTemplate.message));
  }

  static async listVariables() {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: listVariables,
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.listVariables.__typename === 'ListVariablesSuccess') {
      return postData.data.listVariables.result || [];
    }
    return Promise.reject(new Error(postData.data.listVariables.message));
  }

  static async createVariable(name, value) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: createVariable,
      variables: { name, value },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.createVariable.__typename === 'CreateVariableSuccess') {
      return postData.data.createVariable.result;
    }
    return Promise.reject(new Error(postData.data.createVariable.message));
  }

  static async updateVariable(name, value) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: updateVariable,
      variables: { name, value },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.updateVariable.__typename === 'UpdateVariableSuccess') {
      return { result: postData.data.updateVariable.result, changeIds: postData.data.updateVariable.changeIds || [] };
    }
    return Promise.reject(new Error(postData.data.updateVariable.message));
  }

  static async deleteVariable(name) {
    const user = await Auth.currentAuthenticatedUser();
    const postData = await API.graphql({
      query: deleteVariable,
      variables: { name },
      authToken: user.signInUserSession.accessToken.jwtToken,
    });
    if (postData.errors || !postData.data) {
      return Promise.reject(new Error('Internal Server Error'));
    }
    if (postData.data.deleteVariable.__typename === 'DeleteVariableSuccess') {
      return postData.data.deleteVariable.result;
    }
    return Promise.reject(new Error(postData.data.deleteVariable.message));
  }

  // RUBIQ AGENT METHODS_________________________

  static async triggerRubiqAgent({
    projectId,
    conversationId,
    query,
    socketId,
    routeId,
    routeName,
    useStreaming = false // Default to REST mode for better performance
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();

      const postData = await API.graphql({
        query: triggerRubiqAgent,
        variables: {
          projectId: Number(projectId),
          conversationId,
          query,
          socketId,
          routeId,
          routeName,
          jwtToken: user.signInUserSession.accessToken.jwtToken,
          useStreaming // Pass the streaming mode parameter
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) throw new Error('No data returned');

      const res = postData.data.triggerRubiqAgent;

      if (!res) {
        throw new Error('triggerRubiqAgent returned null response');
      }

      if (res.__typename === 'TriggerRubiqAgentSuccess' && res.success) {
        // Return response with mode indicator
        return {
          ...res,
          isDirectResponse: !useStreaming, // Indicates if this is a direct REST response
          useStreaming
        };
      }

      throw new Error(res.message || `RubiqAgentQuery failed with type: ${res.__typename}`);
    } catch (e) {
      console.error('❌ [GraphqlService] Error in triggerRubiqAgent:', e);
      console.error('❌ [GraphqlService] Error type:', typeof e);
      console.error('❌ [GraphqlService] Error message:', e?.message);
      return Promise.reject(e);
    }
  }

  static async fetchDeviceKnowledge(brand, routeId) {
    try {
      const user = await Auth.currentAuthenticatedUser();

      const postData = await API.graphql({
        query: fetchDeviceKnowledge,
        variables: { brand, routeId },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) throw new Error('No data returned');

      const res = postData.data.fetchDeviceKnowledge;

      if (res.__typename === 'FetchDeviceKnowledgeSuccess') {
        return res.id;
      }

      throw new Error(res.message || `Failed with type: ${res.__typename}`);
    } catch (e) {
      console.error('❌ [GraphqlService] Error in fetchDeviceKnowledge:', e);
      return Promise.reject(e);
    }
  }

  static createRubiqAgentSubscription(socketId, onNext, onError) {
    try {
      const observable = API.graphql({
        query: onRubiqAgentQueryResponse,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
        variables: {
          authToken: Auth.user.attributes?.sub || Auth.user.signInUserSession?.accessToken?.payload?.sub,
          socketId,
        },
      });

      if (typeof observable.subscribe !== 'function') {
        const errorMsg = 'Subscription not supported - observable.subscribe is not a function';
        console.error('❌ [GraphqlService]', errorMsg);
        throw new Error(errorMsg);
      }

      console.log('🔧 [GraphqlService] Setting up subscription observable');
      const subscription = observable.subscribe({
        next: ({ value }) => {

          const payload = value?.data?.onRubiqAgentQueryResponse;
          console.log('📡 [GraphqlService] Valid payload found, calling onNext with:', value?.data);
          if (payload) {
            console.log('📡 [GraphqlService] Valid payload found, calling onNext with:', payload);
            onNext(payload);
          } else {
            console.warn('⚠️ [GraphqlService] No payload in subscription response');
            console.warn('⚠️ [GraphqlService] Expected: value.data.onRubiqAgentQueryResponse');
            console.warn('⚠️ [GraphqlService] Got value.data:', value?.data);
          }
        },
        error: (err) => {
          console.error('💥 [GraphqlService] Subscription error details:', err);
          console.error('💥 [GraphqlService] Error type:', typeof err);
          console.error('💥 [GraphqlService] Error message:', err?.message);
          console.error('💥 [GraphqlService] Error code:', err?.code);
          console.error('💥 [GraphqlService] Error errors array:', err?.errors);
          console.error('💥 [GraphqlService] Full error:', JSON.stringify(err, null, 2));
          if (onError) onError(err);
        },
        complete: () => {
          console.log('🏁 [GraphqlService] Subscription completed successfully');
        }
      });

      console.log('✅ [GraphqlService] Subscription created successfully:', subscription);
      console.log('✅ [GraphqlService] Subscription type:', typeof subscription);
      return subscription;
    } catch (err) {
      console.error('🚨 [GraphqlService] Exception creating subscription:', err);
      console.error('🚨 [GraphqlService] Exception type:', typeof err);
      console.error('🚨 [GraphqlService] Exception message:', err?.message);
      console.error('🚨 [GraphqlService] Exception stack:', err?.stack);
      if (onError) onError(err);
      return null;
    }
  }

  // Data Dictionary Methods
  static async exportRecipes({ projectId }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: exportRecipesQuery,
        variables: { projectId },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.exportRecipes.__typename === 'ExportRecipesSuccess') {
        return postData.data.exportRecipes.s3_presigned_url;
      }
      return Promise.reject(new Error(postData.data.exportRecipes.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message}`));
    }
  }

  static async exportEvents({ projectId }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: exportEventsQuery,
        variables: { projectId },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.exportEvents.__typename === 'ExportEventsSuccess') {
        return postData.data.exportEvents.s3_presigned_url;
      }
      return Promise.reject(new Error(postData.data.exportEvents.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message}`));
    }
  }

  static async exportSubevents({ projectId }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: exportSubeventsQuery,
        variables: { projectId },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.exportSubevents.__typename === 'ExportSubeventsSuccess') {
        return postData.data.exportSubevents.s3_presigned_url;
      }
      return Promise.reject(new Error(postData.data.exportSubevents.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message}`));
    }
  }

  static async exportProducts({ projectId }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: exportProductsQuery,
        variables: { projectId },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.exportProducts.__typename === 'ExportProductsSuccess') {
        return postData.data.exportProducts.s3_presigned_url;
      }
      return Promise.reject(new Error(postData.data.exportProducts.message));
    } catch (data) {
      console.error(data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message}`));
    }
  }

  static async importRecipes({ projectId, file }) {
    try {
      console.log('[GraphqlService.importRecipes] Starting import', {
        projectId,
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
      });
      
      const user = await Auth.currentAuthenticatedUser();
      const base64File = await fileToBase64(file);
      
      console.log('[GraphqlService.importRecipes] File converted to base64', {
        base64Size: base64File.length,
      });
      
      // Pass base64 string as required by GraphQL schema (String!)
      const postData = await API.graphql({
        query: importRecipesQuery,
        variables: { projectId, file: base64File },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      
      console.log('[GraphqlService.importRecipes] GraphQL response received');
      
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.importRecipes.__typename === 'ImportRecipesSuccess') {
        return postData.data.importRecipes;
      }
      return Promise.reject(new Error(postData.data.importRecipes.message));
    } catch (data) {
      console.error('[GraphqlService.importRecipes] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message}`));
    }
  }



  static async importEvents({ projectId, file }) {
    try {
      console.log('[GraphqlService.importEvents] Starting import', {
        projectId,
        fileName: file.name,
        fileSize: file.size,
      });
      
      const user = await Auth.currentAuthenticatedUser();
      const base64File = await fileToBase64(file);
      
      console.log('[GraphqlService.importEvents] File converted to base64', {
        base64Size: base64File.length,
      });
      
      // Pass base64 string as required by GraphQL schema (String!)
      const postData = await API.graphql({
        query: importEventsQuery,
        variables: { projectId, file: base64File },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.importEvents.__typename === 'ImportEventsSuccess') {
        return postData.data.importEvents;
      }
      return Promise.reject(new Error(postData.data.importEvents.message));
    } catch (data) {
      console.error('[GraphqlService.importEvents] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message}`));
    }
  }

  static async importSubevents({ projectId, file }) {
    try {
      console.log('[GraphqlService.importSubevents] Starting import', {
        projectId,
        fileName: file.name,
        fileSize: file.size,
      });
      
      const user = await Auth.currentAuthenticatedUser();
      const base64File = await fileToBase64(file);
      
      console.log('[GraphqlService.importSubevents] File converted to base64', {
        base64Size: base64File.length,
      });
      
      // Pass base64 string as required by GraphQL schema (String!)
      const postData = await API.graphql({
        query: importSubeventsQuery,
        variables: { projectId, file: base64File },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.importSubevents.__typename === 'ImportSubeventsSuccess') {
        return postData.data.importSubevents;
      }
      return Promise.reject(new Error(postData.data.importSubevents.message));
    } catch (data) {
      console.error('[GraphqlService.importSubevents] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message}`));
    }
  }

  static async importProducts({ projectId, file }) {
    try {
      console.log('[GraphqlService.importProducts] Starting import', {
        projectId,
        fileName: file.name,
        fileSize: file.size,
      });
      
      const user = await Auth.currentAuthenticatedUser();
      const base64File = await fileToBase64(file);
      
      console.log('[GraphqlService.importProducts] File converted to base64', {
        base64Size: base64File.length,
      });
      
      // Pass base64 string as required by GraphQL schema (String!)
      const postData = await API.graphql({
        query: importProductsQuery,
        variables: { projectId, file: base64File },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      if (postData.data.importProducts.__typename === 'ImportProductsSuccess') {
        return postData.data.importProducts;
      }
      return Promise.reject(new Error(postData.data.importProducts.message));
    } catch (data) {
      console.error('[GraphqlService.importProducts] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message}`));
    }
  }

  static async generateReleaseCandidate({ projectId }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: generateReleaseCandidate,
        variables: {
          projectId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('No data returned from generateReleaseCandidate'));
      }
      if (postData.data.generateReleaseCandidate.__typename === 'GenerateReleaseCandidateSuccess') {
        return Promise.resolve(postData.data.generateReleaseCandidate);
      }
      return Promise.reject(new Error(postData.data.generateReleaseCandidate.message));
    } catch (data) {
      console.error('[GraphqlService.generateReleaseCandidate] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message || data}`));
    }
  }

  static async getReleases({ projectId }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getReleases,
        variables: {
          projectId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('No data returned from getReleases'));
      }
      if (postData.data.getReleases.__typename === 'GetReleasesSuccess') {
        return Promise.resolve(postData.data.getReleases);
      }
      return Promise.reject(new Error(postData.data.getReleases.message));
    } catch (data) {
      console.error('[GraphqlService.getReleases] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message || data}`));
    }
  }

  static async deployReleaseCandidate({ projectId }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: deployReleaseCandidate,
        variables: {
          projectId,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      if (!postData.data) {
        return Promise.reject(new Error('No response from server'));
      }

      if (postData.data.deployReleaseCandidate.__typename === 'DeployReleaseCandidateSuccess') {
        return Promise.resolve(postData.data.deployReleaseCandidate);
      }

      const errorData = postData.data.deployReleaseCandidate;
      return Promise.reject(new Error(errorData.message || 'Failed to deploy release candidate'));
    } catch (data) {
      console.error('[GraphqlService.deployReleaseCandidate] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message || data}`));
    }
  }

  /**
   * Get device quarantine status from Device Defender
   * @param {Object} params - Parameters
   * @param {number} params.projectId - Project ID for multi-tenant isolation
   * @param {string} params.deviceSerial - Device serial number
   * @returns {Promise<Object>} Full response including __typename for state handling
   */
  static async getDeviceQuarantineStatus({ projectId, deviceSerial }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: getDeviceQuarantineStatus,
        variables: {
          projectId,
          deviceSerial,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('No data returned from getDeviceQuarantineStatus'));
      }
      // Return full response for hook to handle different states (NotFound is valid, not an error)
      return Promise.resolve(postData.data.getDeviceQuarantineStatus);
    } catch (data) {
      console.error('[GraphqlService.getDeviceQuarantineStatus] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message || data}`));
    }
  }

  /**
   * Block a device in Device Defender quarantine
   * @param {Object} params - Parameters
   * @param {number} params.projectId - Project ID for multi-tenant isolation
   * @param {string} params.deviceSerial - Device serial number to block
   * @returns {Promise<Object>} Updated quarantine status
   */
  static async blockDevice({ projectId, deviceSerial }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: blockDevice,
        variables: {
          projectId,
          deviceSerial,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('No data returned from blockDevice'));
      }
      const result = postData.data.blockDevice;
      if (result.__typename === 'DeviceQuarantineStatusSuccess') {
        return Promise.resolve(result);
      }
      return Promise.reject(new Error(result.message || 'Failed to block device'));
    } catch (data) {
      console.error('[GraphqlService.blockDevice] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message || data}`));
    }
  }

  /**
   * Release (unblock) a device from Device Defender quarantine
   * @param {Object} params - Parameters
   * @param {number} params.projectId - Project ID for multi-tenant isolation
   * @param {string} params.deviceSerial - Device serial number to release
   * @returns {Promise<Object>} Updated quarantine status
   */
  static async releaseDevice({ projectId, deviceSerial }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: releaseDevice,
        variables: {
          projectId,
          deviceSerial,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('No data returned from releaseDevice'));
      }
      const result = postData.data.releaseDevice;
      if (result.__typename === 'DeviceQuarantineStatusSuccess') {
        return Promise.resolve(result);
      }
      return Promise.reject(new Error(result.message || 'Failed to release device'));
    } catch (data) {
      console.error('[GraphqlService.releaseDevice] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message || data}`));
    }
  }

  /**
   * Get paginated list of blocked devices for a project from Device Defender
   * @param {Object} params - Parameters
   * @param {number} params.projectId - Project ID for multi-tenant isolation
   * @param {number} [params.page] - Page number (1-indexed)
   * @param {number} [params.pageSize] - Items per page
   * @param {string} [params.insertedOnFrom] - Epoch timestamp as string, filter from
   * @param {string} [params.insertedOnTo] - Epoch timestamp as string, filter to
   * @returns {Promise<Object>} Blocked devices with pagination info
   */
  static async getBlockedDevices({ projectId, page, pageSize, insertedOnFrom, insertedOnTo }) {
    const query = `
      query GetBlockedDevices(
        $projectId: Int!
        $page: Int
        $pageSize: Int
        $insertedOnFrom: String
        $insertedOnTo: String
      ) {
        getBlockedDevices(
          projectId: $projectId
          page: $page
          pageSize: $pageSize
          insertedOnFrom: $insertedOnFrom
          insertedOnTo: $insertedOnTo
        ) {
          ... on BlockedDevicesSuccess {
            __typename
            data {
              brand
              blockedDevices {
                deviceSerial
                insertedOn
              }
              pagination {
                pageNumber
                pageSize
                itemsInPage
                totalItems
                totalPages
                isLast
              }
            }
          }
          ... on BadRequest { __typename message statusCode }
          ... on InternalServerError { __typename message statusCode }
          ... on Forbidden { __typename message statusCode }
        }
      }
    `;

    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query,
        variables: { projectId, page, pageSize, insertedOnFrom, insertedOnTo },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });

      const data = postData?.data?.getBlockedDevices;
      if (data?.__typename !== 'BlockedDevicesSuccess') {
        // Handle edge case: API returns error when page > 0 but there are no results
        // Treat "page 1 is greater than the last page: 0" as empty result, not error
        const errorMsg = data?.message || data?.error || JSON.stringify(data) || '';
        if (errorMsg.includes('greater than the last page')) {
          return Promise.resolve({
            brand: projectId,
            blockedDevices: [],
            pagination: {
              pageNumber: 1,
              pageSize,
              itemsInPage: 0,
              totalItems: 0,
              totalPages: 0,
              isLast: true,
            },
          });
        }
        console.error('[GraphqlService.getBlockedDevices] Error:', data);
        return Promise.reject(new Error(data?.message || data?.error || 'Failed to fetch blocked devices'));
      }

      return Promise.resolve(data.data);
    } catch (data) {
      console.error('[GraphqlService.getBlockedDevices] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data.errors?.[0]?.message || data.message || data}`));
    }
  }

  static async estimateExportDuration({
    projectId,
    action,
    dateIni,
    dateEnd,
    filters,
    serialNumber,
    object,
    queryParams,
    totalRows,
  }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const postData = await API.graphql({
        query: estimateExportDuration,
        variables: {
          projectId,
          action,
          dateIni,
          dateEnd,
          filters,
          serialNumber,
          object,
          queryParams,
          totalRows,
        },
        authToken: user.signInUserSession.accessToken.jwtToken,
      });
      if (!postData.data) {
        return Promise.reject(new Error('Internal Server Error'));
      }
      return postData.data.estimateExportDuration;
    } catch (data) {
      console.error('[GraphqlService.estimateExportDuration] Error:', data);
      return Promise.reject(new Error(`Internal Server Error: ${data?.errors?.[0]?.message || data?.message || data}`));
    }
  }
}